import { useTranslation } from 'react-i18next'

import {
  isCampaignCalculationAccountType,
  isCampaignCalculationTiersType,
} from '@model/CampaignCalculationType'
import { isCampaignClientRebateType } from '@model/CampaignType'
import { ClientCampaignRebateResultDto } from '@model/ClientCampaignRebateResultDto'
import { ClientRebateCampaignDetailDto } from '@model/ClientRebateCampaignDetailDto'

import { useFormatNumber } from '@hooks/useFormatNumber'
import { useGenerateDocumentFile } from '@hooks/useGenerateDocumentFile'

export const useCampaignRebateFile = (props: {
  data: ClientCampaignRebateResultDto[]
  campaignDetail?: ClientRebateCampaignDetailDto
}) => {
  const { data, campaignDetail } = props
  const { t } = useTranslation()
  const { formatMoney } = useFormatNumber()

  const getCampaignRebateValue = () => {
    const calcId = campaignDetail?.calculationType?.id
    if (isCampaignCalculationTiersType(calcId)) return t('Campaigns.Tier Reached')
    if (isCampaignCalculationAccountType(calcId)) return t('Account Type')
    return campaignDetail?.calculationType?.name || ''
  }

  const tableBody = () => {
    const currencyFallback =
      campaignDetail?.tradingAccount?.currencyId ?? data?.[0]?.currency?.id ?? 'USD'

    const headerCommon = [t('Campaigns.Round Date'), t('Campaigns.Total Volume Traded')]
    const headerRebate = [t('Campaigns.Accumulated Rebate'), t('Campaigns.Currency')]

    if (
      isCampaignClientRebateType(campaignDetail?.type?.id) &&
      !isCampaignCalculationAccountType(campaignDetail?.calculationType?.id)
    ) {
      const header = [...headerCommon, getCampaignRebateValue(), ...headerRebate]
      const rows = data.map((row) => [
        String(row.round),
        String(row.lots),
        row.rebateValue != null ? String(row.rebateValue) : '',
        String(formatMoney(row.rebate, row.currency.id ?? currencyFallback)),
        String(row.currency.id ?? currencyFallback),
      ])
      return [header, ...rows]
    }

    const header = [...headerCommon, ...headerRebate]
    const rows = data.map((row) => [
      String(row.round),
      String(row.lots),
      String(formatMoney(row.rebate, row.currency.id ?? currencyFallback)),
      String(row.currency.id ?? currencyFallback),
    ])
    return [header, ...rows]
  }

  return useGenerateDocumentFile(
    'campaigns_rebate_report_' + (campaignDetail?.name || 'campaign'),
    tableBody()
  )
}
